import React from "react";
import { CandybarItemConfigType } from "./types";
import CandybarItemConfig from "./CandybarItemConfig";

interface Props {
    configs: Array<CandybarItemConfigType>,
    unitConfig: object|null,
    onOptionSelect: Function,
    isSubConfig?: boolean,
}

function CandybarItemConfigs(props:Props) {
    const { configs, isSubConfig, unitConfig, onOptionSelect } = props;

    if (!configs.length) {
        return null;
    }

    return configs.map(config => <CandybarItemConfig key={config.id} config={config} isSubConfig={isSubConfig || false} unitConfigs={unitConfig} onOptionSelect={onOptionSelect} />);
}

export default CandybarItemConfigs;